module.exports = __webpack_public_path__ + "static/media/WI5.1561db26.jpg";